  // =========================================================
  // Custom script - Developer Louis Schulz - trackt Artikel, die zum Warenkorb hinzugefüt werden
  // =========================================================
(function () {
  const SAVE_URL = '/apps/cart-tracker/save';

  function debounce(fn, wait = 700) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  }

  function getTrackerData() {
    return window.B2B_CART_TRACKER || {};
  }

  function getCardTitle(card) {
    return (
      card?.querySelector('.card__heading')?.textContent?.trim() ||
      card?.querySelector('.full-unstyled-link')?.textContent?.trim() ||
      ''
    );
  }

  function getCardUnitPrice(card) {
    const priceText =
      card?.querySelector('.price-item--sale')?.textContent?.trim() ||
      card?.querySelector('.price-item--regular')?.textContent?.trim() ||
      '';

    if (!priceText) return null;

    const normalized = priceText
      .replace(/[^\d,.-]/g, '')
      .replace(/\./g, '')
      .replace(',', '.');

    const value = Number(normalized);
    return Number.isNaN(value) ? null : value;
  }

  async function sendPayload(payload) {
    if (!payload?.customer_id) return;
    if (!payload?.items?.length) return;

    try {
      await fetch(SAVE_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify(payload),
      });
    } catch (error) {
      console.error('Cart tracking failed:', error);
    }
  }

  function buildBasePayload(source) {
    const tracker = getTrackerData();

    return {
      customer_id: tracker.customerId || null,
      company_name: tracker.companyName || null,
      company_location_name: tracker.companyLocationName || null,
      company_location_id: tracker.companyLocationId || null,
      source,
      total_quantity: 0,
      total_value: null,
      items: [],
      last_updated_at: new Date().toISOString(),
      page_url: window.location.href,
    };
  }

  // =========================================================
  // 1) PRODUCT DETAIL PAGE: quick-order-list
  // =========================================================
  function buildQuickOrderListPayload(root) {
    const payload = buildBasePayload('quick_order_list');
    const rows = root.querySelectorAll('.variant-item, tr[data-variant-id], [data-quantity-variant-id]');
    const items = [];

    rows.forEach((row) => {
      const variantId =
        row.dataset.variantId ||
        row.dataset.quantityVariantId ||
        row.querySelector('[data-variant-id]')?.dataset?.variantId ||
        row.querySelector('input[name="id"]')?.value ||
        null;

      const input =
        row.querySelector('input[type="number"]') ||
        row.querySelector('input[name="updates[]"]') ||
        row.querySelector('.quantity__input');

      const quantity = input ? parseInt(input.value || '0', 10) : 0;

      if (!variantId || quantity < 1) return;

      const title =
        row.querySelector('.variant-item__title')?.textContent?.trim() ||
        row.querySelector('.product-option')?.textContent?.trim() ||
        row.querySelector('.quick-order-list__product')?.textContent?.trim() ||
        '';

      let unitPrice = null;
      const priceHolder = row.querySelector('[data-price]');
      if (priceHolder?.dataset?.price) {
        unitPrice = Number(priceHolder.dataset.price) / 100;
      }

      items.push({
        product_id: null,
        variant_id: String(variantId),
        title,
        quantity,
        unit_price: unitPrice,
      });
    });

    payload.items = items;
    payload.total_quantity = items.reduce((sum, item) => sum + item.quantity, 0);
    payload.total_value = Number(
      items
        .reduce((sum, item) => {
          if (typeof item.unit_price !== 'number' || Number.isNaN(item.unit_price)) return sum;
          return sum + item.unit_price * item.quantity;
        }, 0)
        .toFixed(2)
    );

    return payload;
  }

  const debouncedQuickOrderTrack = debounce((root) => {
    sendPayload(buildQuickOrderListPayload(root));
  }, 900);

  function initQuickOrderTracking() {
    document.addEventListener('change', function (event) {
      const root = event.target.closest('quick-order-list');
      if (!root) return;
      debouncedQuickOrderTrack(root);
    });

    document.addEventListener('click', function (event) {
      const root = event.target.closest('quick-order-list');
      if (!root) return;

      const isRelevantClick =
        event.target.closest('.quantity__button') ||
        event.target.closest('button') ||
        event.target.closest('.button');

      if (!isRelevantClick) return;

      debouncedQuickOrderTrack(root);
    });
  }

  // =========================================================
  // 2) COLLECTION PAGE: quick-add-bulk
  // =========================================================
  function buildQuickAddBulkPayload(quickAddBulk) {
    const payload = buildBasePayload('collection_quick_add_bulk');
    const card = quickAddBulk.closest('.card-wrapper') || quickAddBulk.closest('.card');

    const input = quickAddBulk.querySelector('.quantity__input');
    const quantity = input ? parseInt(input.value || '0', 10) : 0;

    const variantId =
      input?.dataset?.quantityVariantId ||
      quickAddBulk.dataset?.variantId ||
      null;

    const productId =
      quickAddBulk.dataset?.productId ||
      card?.dataset?.productId ||
      null;

    const title = getCardTitle(card);
    const unitPrice = getCardUnitPrice(card);

    payload.items = [
      {
        product_id: productId ? String(productId) : null,
        variant_id: variantId ? String(variantId) : null,
        title: title || '',
        quantity,
        unit_price: unitPrice,
      },
    ];

    payload.total_quantity = quantity;
    payload.total_value =
      typeof unitPrice === 'number' && quantity > 0
        ? Number((unitPrice * quantity).toFixed(2))
        : null;

    return payload;
  }

  const debouncedQuickAddBulkTrack = debounce((quickAddBulk) => {
    sendPayload(buildQuickAddBulkPayload(quickAddBulk));
  }, 700);

  function initQuickAddBulkTracking() {
    document.addEventListener('click', function (event) {
      const button = event.target.closest('.quantity__button');
      if (!button) return;

      const quickAddBulk = button.closest('quick-add-bulk');
      if (!quickAddBulk) return;

      debouncedQuickAddBulkTrack(quickAddBulk);
    });

    document.addEventListener('change', function (event) {
      const input = event.target.closest('.quantity__input');
      if (!input) return;

      const quickAddBulk = input.closest('quick-add-bulk');
      if (!quickAddBulk) return;

      debouncedQuickAddBulkTrack(quickAddBulk);
    });
  }

  // =========================================================
  // 3) GENERIC ADD-TO-CART FORMS
  // =========================================================
  function buildFormPayload(form) {
    const payload = buildBasePayload('generic_add_to_cart');
    const formData = new FormData(form);

    const variantId = formData.get('id');
    const quantity = Number(formData.get('quantity') || 1);

    const card =
      form.closest('.card-wrapper') ||
      form.closest('.card') ||
      form.closest('[data-product-id]');

    const title = getCardTitle(card) || document.title;
    const unitPrice = getCardUnitPrice(card);
    const productId = card?.dataset?.productId || null;

    payload.items = [
      {
        product_id: productId ? String(productId) : null,
        variant_id: variantId ? String(variantId) : null,
        title,
        quantity,
        unit_price: unitPrice,
      },
    ];

    payload.total_quantity = quantity;
    payload.total_value =
      typeof unitPrice === 'number'
        ? Number((unitPrice * quantity).toFixed(2))
        : null;

    return payload;
  }

  const debouncedFormTrack = debounce((form) => {
    sendPayload(buildFormPayload(form));
  }, 400);

  function initGenericFormTracking() {
    document.addEventListener(
      'submit',
      function (event) {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        const action = form.getAttribute('action') || '';
        if (!action.includes('/cart/add')) return;

        debouncedFormTrack(form);
      },
      true
    );
  }

  // =========================================================
  // INIT
  // =========================================================
  initQuickOrderTracking();
  initQuickAddBulkTracking();
  initGenericFormTracking();
})();